import apiClient from "./apiClient";

export const listTeamMembers = async ({ search = "", page = 1 } = {}) => {
  const { data } = await apiClient.get("/team-members", {
    params: { search: search || undefined, page },
  });
  return { members: data.data, pagination: data.meta.pagination };
};

export const createTeamMember = async (payload) => {
  const { data } = await apiClient.post("/team-members", payload);
  return data.data;
};

export const updateTeamMember = async (id, payload) => {
  const { data } = await apiClient.put(`/team-members/${id}`, payload);
  return data.data;
};

export const deleteTeamMember = async (id) => {
  await apiClient.delete(`/team-members/${id}`);
};
